import React, { useState } from 'react';
import vendorsData from '../../Datas/VendorsData';
import VendorModal from '../VendorModal/VendorModal';
import MedicineSearchModal from '../MedicineSearchModal/MedicineSearchModal'; 
import './VendorsList.css';

const VendorsList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const openModal = (vendor) => {
    setSelectedVendor(vendor);
  };

  const closeModal = () => {
    setSelectedVendor(null);
  };

  const openMedicineSearchModal = () => {
    setIsModalOpen(true);
  };

  const closeMedicineSearchModal = () => {
    setIsModalOpen(false);
  };

  const filteredVendors = vendorsData.filter(vendor =>
    vendor.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  const vendorBackgrounds = [
    '#024950',    
  ];

  return (
    <div className="vendors-list-wrapper">
      <div className="vendors-search-wrapper">
        <input 
          type="text" 
          placeholder="Search by vendor name..." 
          value={searchQuery}
          onChange={handleSearch}
          className="vendors-search-input"
        />
        <button className="vendors-search-button" onClick={openMedicineSearchModal}>Search by Medicine</button>
      </div>

      <div className="vendors-cards-container">
        {filteredVendors.map((vendor, index) => (
          <div 
            key={vendor.id} 
            className="vendor-card" 
            onClick={() => openModal(vendor)} 
            style={{ '--vendor-card-bg': vendorBackgrounds[index % vendorBackgrounds.length] }} 
          >
            <div className="vendor-card-header">
              <p className='vendor-name'>{vendor.name}</p>
            </div>

            <div className="vendor-card-body">
              <h4>Location:</h4>
              <p>{vendor.location}</p>
            </div>

            <div className="vendor-card-footer">
              <button className="view-details-btn">View Details</button>
            </div>

            <div className={`vendor-status ${vendor.isUsingSoftware ? 'vendor-verified' : 'vendor-not-verified'}`}>
              {vendor.isUsingSoftware ? '✅' : '❌'}
            </div>
          </div>
        ))}
      </div>

      {selectedVendor && <VendorModal vendor={selectedVendor} onClose={closeModal} />}
      
      {isModalOpen && (
        <MedicineSearchModal 
          vendorsData={vendorsData} 
          onClose={closeMedicineSearchModal} 
        />
      )}
    </div>
  );
};

export default VendorsList;
